import React from "react";
import PropTypes from "prop-types";

export default function LegacyIndicator({ visible }) {
  if (visible) {
    return (
      <div className="card-panel no-card-bottom-padding">
        <div className="card-title custom-card warning-card">
          <div className="view-title">
            <i className="left material-icons warning-icon">warning</i>
            <span className="title">
              This estimate was created in an earlier version of CAVS and cannot
              be edited.
            </span>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

LegacyIndicator.propTypes = {
  visible: PropTypes.bool,
};
